import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type HubspotWorkflow } from 'entities/HubspotWorkflows/model/HubspotWorkflow'

export class HubspotWorkflowRow extends RowBase<HubspotWorkflow> {
  constructor(origin: HubspotWorkflow) {
    super(origin)

    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get workflowId() {
    return this.origin.workflowId
  }

  get firstMessageDate() {
    return this.origin.firstMessageDate
  }

  get total() {
    return this.origin.total
  }
}
